import { store } from 'store/index';
import { SET_PERIODO_FISCAL_SELECTED, UPDATE_ENTIDAD_INFO } from 'store/reducers/auth';
import {
  SET_CORTE,
  SET_SOCKETS_CONNECTED,
} from 'store/reducers/app';
import {
  SET_NETPAY_RESPONSE,
  SET_RECIBOS,
  SET_RECIBOS_CANCELADOS,
} from 'store/reducers/caja';
import { logger } from 'utils/debug';

export default (io) => {
  if (io) {
    io.on('connect', () => {
      logger('sockets connected');
      store.dispatch({
        type: SET_SOCKETS_CONNECTED,
        payload: true,
      });
    });
    io.on('connect_error', (error) => {
      logger(error);
      store.dispatch({
        type: SET_SOCKETS_CONNECTED,
        payload: false,
      });
    });
    io.on('disconnect', (reason) => {
      logger(`sockets disconnected, reason: ${reason}`);
      if (reason === 'io server disconnect') {
        // the disconnection was initiated by the server, you need to reconnect manually
        io.connect();
      }
      // else the socket will automatically try to reconnect
    });
    io.on('periodo_fiscal_vigente', (data) => {
      store.dispatch({
        type: SET_PERIODO_FISCAL_SELECTED,
        payload: data.object,
      });
    });
    io.on('update_administradores_de_la_entidad', (data) => {
      const { objects, removed } = data;
      const { entidad } = store.getState().auth;
      if (objects.length) {
        entidad.administradores.concat(objects);
        store.dispatch({
          type: UPDATE_ENTIDAD_INFO,
          payload: entidad,
        });
      } else if (removed.length) {
        const [removedID] = removed;
        entidad.administradores = entidad.administradores.filter((e) => e.id !== removedID);
        store.dispatch({
          type: UPDATE_ENTIDAD_INFO,
          payload: entidad,
        });
      }
    });
    io.on('corte', (data) => {
      store.dispatch({
        type: SET_CORTE,
        payload: data,
      });
    });
    io.on('corte_cerrado', () => {
      store.dispatch({
        type: SET_CORTE,
        payload: null,
      });
    });
    io.on('recibo_netpay', (data) => {
      // este if es para los recibos cancelados
      if (data.id_recibo?.length && data?.message === 'Recibido' && data?.status_code === '00') {
        store.dispatch({
          type: SET_RECIBOS_CANCELADOS,
          payload: data.id_recibo,
        });
      }

      // este if es para las ventas
      if (data.id_recibo?.length && data?.message !== 'Recibido') {
        store.dispatch({
          type: SET_RECIBOS,
          payload: data.id_recibo,
        });
      } else {
        store.dispatch({
          type: SET_NETPAY_RESPONSE,
          payload: data,
        });
      }
    });
  } else {
    store.dispatch({
      type: SET_SOCKETS_CONNECTED,
      payload: false,
    });
  }
};
